import request from '../utils/request';

// 获取轮播图列表
export const getBannerList = () => {
  return request({
    url: '/api/manage/getBannerList',
    method: 'get'
  });
};

// 保存轮播图
export const saveBanner = (data) => {
  return request({
    url: '/api/manage/saveBanner',
    method: 'post',
    data
  });
};
